import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/auth/auth_service';

/**
 * Core email verification logic. Accepts injected services so it can be called
 * from contexts without injection (e.g. RxJS callbacks).
 */
export async function checkEmailVerified(
  authService: AuthenticationService,
  router: Router,
  state: RouterStateSnapshot
): Promise<boolean> {
  const app = environment.app;

  // Only enforce email verification for trials app
  if (app !== 'trials' && app !== 'trialsClinic') {
    return true;
  }

  // Reload token and check verification status
  const isVerified = await authService.reloadAndCheckVerification();
  if (!isVerified) {
    router.navigate(['/verify-email'], {
      queryParams: { redirectTo: state.url },
      queryParamsHandling: 'merge',
    });
    return false;
  }

  return true;
}

/**
 * Guard that checks if the user's email is verified.
 * Only active for trials app - redirects unverified users to verify-email page.
 * For other apps, it always allows access.
 */
export const EmailVerifiedGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  return checkEmailVerified(authService, router, state);
};
